<div class="filter-panel">

  <!-- Project -->
  <div class="filter-section">
    <label class="filter-label">Project</label>
    <nz-select
      class="filter-select"
      [(ngModel)]="selectedProject"
      nzPlaceHolder="Select project"
      nzShowSearch
      [nzLoading]="loading.projects ?? false"
      (ngModelChange)="onFieldChange('project')"
    >
      <nz-option
        *ngFor="let opt of projects"
        [nzValue]="opt.value"
        [nzLabel]="opt.label"
      ></nz-option>
    </nz-select>
  </div>

  <!-- User -->
  <div class="filter-section">
    <label class="filter-label">User</label>
    <nz-select
      [class]="selectedUser ? 'filter-select user-select' : 'filter-select'"
      [(ngModel)]="selectedUser"
      nzPlaceHolder="Select user"
      nzShowSearch
      [nzLoading]="loading.users ?? false"
      (ngModelChange)="onFieldChange('user')"
    >
      <nz-option
        *ngFor="let opt of users"
        [nzValue]="opt.value"
        [nzLabel]="opt.label"
        nzCustomContent
      >
        <div class="user-option">
          <img *ngIf="opt.avatarUrl" class="user-option-avatar" [src]="opt.avatarUrl" alt="" />
          <span *ngIf="!opt.avatarUrl" class="user-option-avatar user-option-initials">
            <mat-icon>person</mat-icon>
          </span>
          <span class="user-option-label">{{ opt.label }}</span>
        </div>
      </nz-option>
    </nz-select>
    <div class="user-select-display" *ngIf="selectedUser">
      <div class="user-avatar-wrap" *ngIf="getSelectedUserAvatar()">
        <img class="user-avatar" [src]="getSelectedUserAvatar()" alt="user avatar" />
      </div>
      <div class="user-avatar-wrap user-initials" *ngIf="!getSelectedUserAvatar()">
        <mat-icon>person</mat-icon>
      </div>
    </div>
  </div>

  <!-- Time frame -->
  <div class="filter-section">
    <label class="filter-label">Time frame</label>
    <div class="time-frame">
      <div class="timeframe-tabs" [class.all-selected]="selectedTimeFrame === 'All'">
      <button
        *ngFor="let frame of timeFrameOptions"
        class="timeframe-btn"
        [class.active]="selectedTimeFrame === frame"
        (click)="selectTimeFrame(frame)"
        type="button"
      >
        {{ frame }}
      </button>
    </div>

    <nz-range-picker
      *ngIf="selectedTimeFrame !== 'All'"
      class="date-picker"
      [nzMode]="pickerMode"
      [(ngModel)]="dateRange"
      (ngModelChange)="onDateRangeChange($event)"
      nzSize="small"
    ></nz-range-picker>
    </div>
  </div>

  <!-- ALM Provider -->
  <div class="filter-section">
    <label class="filter-label">LLM Provider</label>
    <nz-select
      class="filter-select"
      [(ngModel)]="selectedAlmProvider"
      nzPlaceHolder="Select LLM provider"
      nzShowSearch
      [nzLoading]="loading.almProviders ?? false"
      (ngModelChange)="onFieldChange('almProvider')"
    >
      <nz-option
        *ngFor="let opt of almProviders"
        [nzValue]="opt.value"
        [nzLabel]="opt.label"
      ></nz-option>
    </nz-select>
  </div>

  <!-- Model -->
  <div class="filter-section">
    <label class="filter-label">Model</label>
    <nz-select
      class="filter-select"
      [(ngModel)]="selectedModel"
      nzPlaceHolder="Select model"
      nzShowSearch
      [nzLoading]="loading.models ?? false"
      (ngModelChange)="onFieldChange('model')"
    >
      <nz-option
        *ngFor="let opt of models"
        [nzValue]="opt.value"
        [nzLabel]="opt.label"
      ></nz-option>
    </nz-select>
  </div>

</div>
